// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__11_Se","col":"styles_col__Y2mS2"};